import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "./styles/web3-theme.css";
import "./styles/blue-overrides.css";
import "./ui/tokens/spacing.css";
import "./ui/tokens/surfaces.css";
import "./ui/layout/landing.css";
import { initTheme } from "./utils/theme";
import axios from "axios";

import { headerData } from "./components/GenericFunctions";
import reportWebVitals from "./reportWebVitals";
import { logWebVitals } from "./utils/reportWebVitalsLogger";
import { registerChunkLoadRecovery } from "./utils/chunkLoadRecovery";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import App from "./App";
import "react-bootstrap-country-select/dist/react-bootstrap-country-select.css";

initTheme();

Object.assign(axios.defaults.headers.common, headerData);

registerChunkLoadRecovery();

if (process.env.NODE_ENV !== "production") {
  require("dotenv").config();
}

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  // <React.StrictMode>
  <App />
  // <MainDashBoard></MainDashBoard>,

  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(logWebVitals);
